import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  App,
} from 'ionic-angular';
import * as debug from 'debug';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { UserProvider } from '../../providers/user/user';
import * as _ from 'lodash';
import { ToolsProvider } from '../../providers/tools/tools';
import { MessagesProvider } from '../../providers/messages/messages';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';

@Component({
  selector: 'new-group-chat-startup',
  templateUrl: 'new-group-chat-startup.html',
})
export class NewGroupChatStartupComponent {
  @Input() selectedFriendList;
  @Output() clearSelectedFriends = new EventEmitter();

  groupName = '';
  editedList = [];

  log = debug('app:NewGroupChatStartupComponent');
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    public loadingCtrl: LoadingController,
    public appCtrl: App,
    public messaging: MessagesProvider,
    public tools: ToolsProvider,
    public userVerification: UserVerificationProvider
  ) {}

  ngOnInit(): void {}

  removeFromSendList(friend) {
    this.editedList = this.selectedFriendList;
    _.filter(this.editedList, function (item) {
      if (item._id === friend._id) {
        _.set((item.isChecked = false));
      }
    });
  }

  async createGroupChat(type?) {
    if (!(await this.userVerification.isVerified())) {
      return;
    }

    let users = [];
    _.map(this.selectedFriendList, friends => {
      users.push(friends._id);
    });

    this.tools.logAnalyticsEvent('trackCustom', 'friends-create-convo');
    this.tools.checkCanMessage().then(canMessage => {
      if (canMessage) {
        this.messaging
          .createNewConversation(users, this.groupName, type)
          .then(convo => {
            // TODO navTo
            // this.tools.openExternalUrl(
            //   `/contacts/friends-message/${convo._id}`,
            //   'deep-link',
            //   {
            //     setTab: 'messages',
            //     conversation: convo,
            //   }
            // );
            this.tools.navTo('FriendsMessagePage', 2, {
                conversation_id: convo._id,
                conversation: convo,
              });
            this.clearSelectedFriends.emit();
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/new-group-chat-startup/new-group-chat-startup.ts